import React, {useEffect, useState} from 'react';
import  {Link} from 'react-router-dom';
import {Button} from '../../Button.js';

import { FaBars, FaTimes } from 'react-icons/fa';
import '../../Button.css';
import {IconContext} from 'react-icons/lib';

require('./Navbar.css');


function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if(window.innerWidth <= 960){
        setButton(false);
    } else{
        setButton(true);
    }
  }

  useEffect(() => {showButton(); }, []);


  window.addEventListener('resize', showButton);

  return (
  
  <>
<IconContext.Provider value={{color: '#fff'}}>
<div className='navbar'>
  <div className='navbar-container container'>

    <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
        <img src={require("./urebacafelogo1.jpg")} alt='Logo' 
           className='navbar-icon' />
          YB Code Lab
    </Link>

    <Link  to='/privpol' className='btn-link'>
               <Button buttonStyle='btn--outline'>BB Privacy Policy</Button>
              </Link>



    <div className='menu-icon' onClick={handleClick}>
        {click ? <FaTimes /> : <FaBars /> }
    </div>

    <ul className={click ? 'nav-menu active' : 'nav-menu'}>

        <li>
        <Link to='/' className='nav-links' onClick={closeMobileMenu}>
          Home
        </Link>
        </li>

          <li className='nav-item'>
            <Link to='/products' className='nav-links' onClick={closeMobileMenu}>
              Products
            </Link>
          </li>

        

          <li className='nav-item'>
            <Link to='/services' className='nav-links' onClick={closeMobileMenu}>
              Services
            </Link>
          </li>



          <li className='nav-btn'>
          {button ? (
              <Link  to='/sign-up' className='btn-link'>
               <Button buttonStyle='btn--outline'>Sign Up</Button>
              </Link>) 
              : 
              (<Link  to='/sign-up' className='btn-link'>
                  <Button buttonStyle='btn--outline' buttonSize='btn--mobile'>
                    Sign Up
                  </Button>
                 </Link>)}
          </li>

</ul>
 
</div> 
 
</div>

<div>
  </div>
</IconContext.Provider>

  </>
  );
}

export default Navbar